import type { TableTemplateElementType } from '../interfaces'

export const nonTableSizes: Partial<
  Record<TableTemplateElementType, Record<string, { width: number; height: number }>>
> = {
  sofa: {
    '1': { width: 100, height: 100 }, // viewBox 150×150 (1:1)
    'round-1': { width: 160, height: 90 }, // viewBox 262×147 (1.78:1)
    '3': { width: 200, height: 73 }, // viewBox 406×149 (2.73:1)
    'armless-3': { width: 200, height: 70 }, // viewBox 406×141 (2.88:1)
    'round-3': { width: 200, height: 104 }, // viewBox 502×262 (1.92:1)
  },
  kitchen: {
    default: { width: 200, height: 48 }, // viewBox 758×181 (4.19:1)
    l: { width: 100, height: 148 }, // viewBox 512×758 (0.68:1)
  },
  wall: {
    default: { width: 200, height: 41 }, // viewBox 156×32 (4.88:1)
    curve: { width: 174, height: 87 }, // viewBox 174x87 (2:1)
    'half-curve': { width: 100, height: 100 }, // viewBox 120×100 (1:1)
  },
  'glass-wall': {
    default: { width: 200, height: 20 }, // viewBox 320×32 (10:1)
  },
  pool: {
    default: { width: 200, height: 134 }, // viewBox 466×312 (1.49:1)
    circle: { width: 200, height: 134 }, // viewBox 466×312 (1.49:1)
  },
  stairs: {
    l: { width: 160, height: 138 }, // viewBox 405×350 (1.16:1)
    square: { width: 100, height: 98 }, // viewBox 414×405 (1.02:1)
    circle: { width: 100, height: 99 }, // viewBox 470×464 (1.01:1)
  },
  tree: {
    '1': { width: 180, height: 180 },
    '2': { width: 180, height: 180 },
    '3': { width: 180, height: 180 },
    '4': { width: 180, height: 180 },
    '5': { width: 180, height: 180 },
  },
  plant: {
    '1': { width: 160, height: 160 },
    '2': { width: 160, height: 160 },
    '3': { width: 160, height: 160 },
    '4': { width: 160, height: 160 },
    '5': { width: 160, height: 160 },
    '6': { width: 160, height: 160 },
    '7': { width: 160, height: 160 },
    '8': { width: 160, height: 160 },
  },
  'plant-box': {
    '1': { width: 180, height: 180 },
    '2': { width: 180, height: 180 },
    '3': { width: 180, height: 180 },
  },
  door: {
    '1': { width: 164, height: 164 },
    '2': { width: 164, height: 164 },
  },
  chair: {
    default: { width: 40, height: 40 },
  },
  bar: {
    l: { width: 160, height: 129 },
    horizontal: { width: 200, height: 77 },
  },
  flooring: {
    '1': { width: 200, height: 200 },
    '2': { width: 200, height: 200 },
    '3': { width: 200, height: 200 },
    '4': { width: 200, height: 200 },
    '5': { width: 200, height: 200 },
    '6': { width: 200, height: 200 },
    '7': { width: 200, height: 200 },
    '8': { width: 200, height: 200 },
    '9': { width: 200, height: 200 },
  },
}

export const flooringDefaultPatternSize = 400

export function getTableMapDefaultSize(
  type: TableTemplateElementType,
  shape: string,
  value: number,
): { width: number; height: number } {
  if (type === 'table') return value >= 9 ? { width: 392, height: 392 } : { width: 196, height: 196 }
  else if (type === 'seat') return { width: 80, height: 80 }
  return nonTableSizes[type]?.[shape] ?? { width: 100, height: 100 }
}

export function getElementIconName(type: TableTemplateElementType, shape: string): string {
  if (type === 'sofa') return `sofa-${shape}`
  else if (type === 'kitchen') return shape === 'l' ? 'kitchen-l' : 'kitchen'
  else if (type === 'wall') return shape === 'default' ? 'wall' : `${shape}-wall`
  else if (type === 'glass-wall') return 'glass-wall'
  else if (type === 'pool') return shape === 'circle' ? 'pool-circle' : 'pool'
  else if (type === 'stairs') return `stairs-${shape}`
  else if (type === 'tree') return `tree-${shape}`
  else if (type === 'plant') return `plant-${shape}`
  else if (type === 'plant-box') return `plant-box-${shape}`
  else if (type === 'door') return `door-${shape}`
  else if (type === 'flooring') return `flooring-${shape}`
  else if (type === 'bar') return `bar-${shape}`
  return type
}

export const tableTemplateTableTypes: TableTemplateElementType[] = ['table', 'seat']

export const LAYER_LABELS: Partial<Record<TableTemplateElementType, string>> = {
  table: 'layer_labels.table',
  seat: 'layer_labels.seat',
  bar: 'layer_labels.bar',
  sofa: 'layer_labels.sofa',
  chair: 'layer_labels.chair',
  flooring: 'layer_labels.flooring',
  wall: 'layer_labels.wall',
  door: 'layer_labels.door',
  'glass-wall': 'layer_labels.glass_wall',
  tree: 'layer_labels.tree',
  plant: 'layer_labels.plant',
  'plant-box': 'layer_labels.plant_box',
  kitchen: 'layer_labels.kitchen',
  stairs: 'layer_labels.stairs',
  pool: 'layer_labels.pool',
}
